export default __webpack_public_path__ + "img/sec-1-bg.png";